<template>
  <v-table>
    <tbody>
      <tr>
        <td><strong>Bio:</strong></td>
        <td>
          <div v-html="branch.bio"></div>
        </td>
      </tr>
      <tr>
        <td><strong>Website:</strong></td>
        <td>
          <a :href="`{{ branch.website }}`">{{ branch.website }}</a>
        </td>
      </tr>
      <tr>
        <td><strong>Facebook:</strong></td>
        <td v-if="branch.facebook">
          <a :href="`https://www.facebook.com/${branch.facebook}`">@{{ branch.facebook }}</a>
        </td>
        <td v-else></td>
      </tr>
      <tr>
        <td><strong>X:</strong></td>
        <td v-if="branch.twitter">
          <a :href="`https://www.x.com/${branch.twitter}`">@{{ branch.twitter }}</a>
        </td>
        <td v-else></td>
      </tr>
      <tr>
        <td><strong>Instagram</strong></td>
        <td v-if="branch.instagram">
          <a :href="`https://www.instagram.com/${branch.instagram}`">@{{ branch.instagram }}</a>
        </td>
        <td v-else></td>
      </tr>
      <tr>
        <td><strong>YouTube</strong></td>
        <td v-if="branch.youtube">
          <a :href="`https://www.youtube.com/@${branch.youtube}`">@{{ branch.youtube }}</a>
        </td>
        <td v-else></td>
      </tr>
      <tr v-if="branch.vimeo">
        <td><strong>Vimeo</strong></td>
        <td v-if="branch.vimeo">
          <a :href="`https://www.vimeo.com/${branch.vimeo}`">@{{ branch.vimeo }}</a>
        </td>
        <td v-else></td>
      </tr>
    </tbody>
  </v-table>
</template>
<script setup lang="ts">
import { BranchDTO, IBranchDTO } from '@/dtos';
import { ref, watch } from 'vue';

interface Props {
  branch: IBranchDTO;
}
const props = defineProps<Props>();

const branch = ref<IBranchDTO>(new BranchDTO());

watch(
  () => props.branch,
  (newVal) => {
    if (newVal) {
      branch.value = new BranchDTO(newVal);
    }
  },
  { immediate: true },
);
</script>
